import React from 'react'
import IconTick from '@svgs/IconTick'
import {
    CheckboxContainer,
    CheckboxTick,
    CheckboxLabel
} from './index.style'

const Checkbox = ({
    name,
    value,
    requierd,
    checked,
    onChange,
    children
}) => {
    const checkboxInput = requierd ? (<input type="checkbox" name={name} defaultChecked={checked} requierd="true" onChange={onChange}></input>): 
    (<input type="checkbox" name={name} defaultChecked={checked} onChange={onChange}></input>);
    return (
        <CheckboxContainer>
            {checkboxInput}
            <CheckboxTick className="tick">
                <IconTick />
            </CheckboxTick>
            <CheckboxLabel>{children}</CheckboxLabel>
        </CheckboxContainer>
    )
}
export default Checkbox